




























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { CvValue, Resource } from '@/models'

// code is a stable slug: lowercase letters, digits, '-' and '_'.
const CODE_REGEX = /^[a-z0-9][a-z0-9_-]*$/

function emptyForm(): Resource {
  return { code: '', name: '', category: '', active: true, provisionRefs: '', displayOrder: 0 }
}

@Component
export default class UpsertResourceModal extends Vue {
  @Prop({ required: false }) resource: Resource | null
  @Prop({ default: () => [] }) categories: CvValue[]

  private form: Resource = emptyForm()
  private saving = false

  @Watch('resource', { deep: true })
  onResourceChanged() {
    this.form = this.resource ? { ...this.resource } : emptyForm()
  }

  get isNew(): boolean {
    return this.resource == null || this.resource.id == null
  }

  get codeState(): boolean | null {
    if (!this.form.code) return null
    return CODE_REGEX.test(this.form.code)
  }

  private formOk(): boolean {
    if (!this.form.code || !this.form.name || !this.form.name.trim() || !this.form.category) return false
    return CODE_REGEX.test(this.form.code)
  }

  hideModal() {
    this.$bvModal.hide('UpsertResourceModal')
  }

  private saveForm(): void {
    if (!this.formOk() || this.saving) return

    const payload: Resource = {
      ...this.form,
      code: this.form.code.trim().toLowerCase(),
      name: this.form.name.trim(),
      displayOrder: typeof this.form.displayOrder === 'number' && !isNaN(this.form.displayOrder)
        ? this.form.displayOrder : 0
    }

    const promise = this.isNew
      ? ApiClient.createResource(payload)
      : ApiClient.updateResource(this.resource!.id as number, payload)

    this.saving = true
    promise
      .then((saved: Resource) => {
        this.$emit('saved', saved)
        this.hideModal()
        this.form = emptyForm()
      })
      .catch((ex: Error) => {
        this.$bvToast.toast(ex.message, {
          title: this.$t('feedback.error_title_generic').toString(),
          variant: 'danger',
          solid: true
        })
      })
      .finally(() => {
        this.saving = false
      })
  }
}
